export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';

interface Props {
    bubbleKey: number
    content: string
    typing: boolean | {
        interval: number
        step: number
    }
    modeLabel: string
    completeCount: number
}

const fullText = 'Bubble 的 typing 会在内容稳定后逐步推进，适合回答生成完成后的展示动画。';

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            bubbleKey: 0,
            content: fullText,
            typing: false,
            modeLabel: '未播放',
            completeCount: 0,
        };
    }

    play(interval: number, step: number, modeLabel: string) {
        this.set({
            bubbleKey: this.get('bubbleKey') + 1,
            content: fullText,
            typing: {interval, step},
            modeLabel,
            completeCount: 0,
        });
    }

    @bind
    playSlow() {
        this.play(80, 2, '慢速播放');
    }

    @bind
    playFast() {
        this.play(24, 6, '快速播放');
    }

    @bind
    playCharacterByCharacter() {
        this.play(48, 1, '逐字播放');
    }

    @bind
    onTypingComplete() {
        this.set('completeCount', this.get('completeCount') + 1);
    }
}